import React from 'react';
import { Box } from '@material-ui/core';
import { formatDate } from '../../utils';

export const CreatedAtRowsComponent = ({ created_at }: { created_at?: Date }) => <Box>{created_at ? formatDate(created_at, true, false) : 'Invalid Date'}</Box>;
